export const ZUKER_FLOOR_LIST = {
  name: '获取楼层列表',
  api: '${ZUKER}/ma-tenant/api/D/lbs/getFloorListByBidAndBuildId',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#d467f92e0e1bc3f7eccf7c41ddeb24ca',
};

export const REPAIR_TYPE_LIST = {
  name: '获取报修类型列表',
  api: '${ZUKER}/ma-tenant/maintain/repair/type/list',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#45f02c6fd187dbcfa071e53d85f4d207',
};

export const REPAIR_MAINTAINER_LIST = {
  name: '获取维修工人员列表',
  api: '${ZUKER}/ma-tenant/api/D/account/listByFunctionId',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#221fd658f289d76250b49b331d3cfdf5',
};

// export const REPAIR_LIST = {
// 	name: '获取报修工单列表',
// 	api: '${ZUKER}/ma-tenant/maintain/page/list',
// 	method: 'post',
// 	doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#3d4a6d9124d8bfc974d3bdde201bf45f',
// };

export const REPAIR_ADD = {
  name: '添加报修工单',
  api: '${ZUKER}/ma-tenant/maintain/add',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#076eea6387c20e802aba27a5c77e500a',
};

export const REPAIR_INFO = {
  name: '获取报修工单详情',
  api: '${ZUKER}/ma-tenant/maintain/detail',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#e6fd80075ccd29f3764026d7d0d192e5',
};

export const REPAIR_ASSIGN_MAINTAINER = {
  name: '指派维修工',
  api: '${ZUKER}/ma-tenant/maintain/assign',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#adf522f5aebbaa4ce25903cb3b4f0abe',
};

export const REPAIR_URGE = {
  name: '工单催办',
  api: '${ZUKER}/ma-tenant/maintain/urge',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#257f6073ab29104335f2bc554411109e',
};

export const REPAIR_EXPORT = {
  name: '工单导出',
  api: '${ZUKER}/ma-tenant/maintain/export',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#aa6b78662a9601a2e21ea315300a7f8e',
};

export const REPAIR_STATISTICS = {
  name: '工单统计',
  api: '${ZUKER}/ma-tenant/maintain/statistics',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#3ee66d3739d1cb0e96660bbcf2ff5250',
};

export const REPAIR_STATISTICS_EXPORT = {
  name: '导出工单统计',
  api: '${ZUKER}/ma-tenant/maintain/export',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#aa6b78662a9601a2e21ea315300a7f8e',
};

export const REPAIR_APPRAISAL_LIST = {
  name: '工单评价设置列表',
  api: '${ZUKER}/ma-tenant/appraisal/conf/pageList',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#9e1fd5d986033cd96b3563bc91c0ee3a',
};

export const REPAIR_APPRAISAL_INFO = {
  name: '工单评价设置详情',
  api: '${ZUKER}/ma-tenant/appraisal/conf',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#27821a59a7519b60df071f423da49e3d',
};

export const REPAIR_APPRAISAL_ADD = {
  name: '添加工单评价设置',
  api: '${ZUKER}/ma-tenant/appraisal/conf/save',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#504e915ff0c566610e44ebca19bc8f84',
};

export const REPAIR_APPRAISAL_UPDATE = {
  name: '更新工单评价设置',
  api: '${ZUKER}/ma-tenant/appraisal/conf/update',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#8a36531b0f27f7fd41c40eeed8691d98',
};

export const REPAIR_APPRAISAL_REMOVE = {
  name: '删除工单评价设置',
  api: '${ZUKER}/ma-tenant/appraisal/conf/delete',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#8cd67984b7bf2c250e5f00d4ca97f366',
};

export const REPAIR_URGE_INFO = {
  name: '工单催办设置详情',
  api: '${ZUKER}/ma-tenant/urge/conf',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#d8a9295edcc0cc1289eb9c7b1fae6df6',
};

export const REPAIR_URGE_UPDATE = {
  name: '更新工单催办设置',
  api: '${ZUKER}/ma-tenant/urge/conf/save',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#ccfed8a7a2e88d567465735cc27c0319',
};

export const PAYMENT_LIST = {
  name: '查询支付类型列表',
  api: '${ZUKER}/ma-tenant/sale/payment/type/list',
  method: 'get',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#fbf0e4c16abd07d84b5edad9eb8dbdef',
};

export const SALE_RECORD_ADD = {
  name: '添加销售记录',
  api: '${ZUKER}/ma-tenant/sale/record/add',
  method: 'POST',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#f10c7d0455d65e11f4f5445215e1315b',
};

export const REPORT_REVOKE = {
  name: '撤回销售记录',
  api: '${ZUKER}/ma-tenant/sale/record/revoke',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#42a7d65f5786c7f293b2d01e6777dc3c',
};

export const REPORT_LIST = {
  name: '获取上报销售列表',
  api: '${ZUKER}/ma-tenant/sale/record/list',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#1eb45605705b77c9d213cb5605d9f158',
};

export const REPORT_INFO = {
  name: '获取上报销售详情',
  api: '${ZUKER}/ma-tenant/sale/record/detail',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#0e169afae19858def18b309d1cab3c7a',
};

export const REPORT_INFO_REJECT = {
  name: '审核驳回销售上报',
  api: '${ZUKER}/ma-tenant/sale/record/audit/fail',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#6ede0cbdf9f14ba1e458b374d1ef98f0',
};

export const REPORT_INFO_RESOLVE = {
  name: '审核通过销售上报',
  api: '${ZUKER}/ma-tenant/sale/record/audit/pass',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#4a4e371c95aeebb01c922036fdc0f9c5',
};

export const REPORT_RANK_SALE = {
  name: '商户销售额排行',
  api: '${ZUKER}/ma-tenant/sale/statistics/sales/list',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#e6effd3bb42b6a798db3a275cbf8ad80',
};

export const REPORT_RANK_PER = {
  name: '商户坪效排行',
  api: '${ZUKER}/ma-tenant/sale/statistics/effect/list',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#986f79e50e33df5c618c677c4005ec66',
};

export const REPORT_RANK_CATEGORY = {
  name: '业态销售占比',
  api: '${ZUKER}/ma-tenant/sale/statistics/category/sales/list',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#e091287e016a6869e6012f766e531720',
};

export const REPORT_RANK_FLOOR = {
  name: '楼层销售占比',
  api: '${ZUKER}/ma-tenant/sale/statistics/floor/sales/list',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#e75aabf45860aa7f3c31592453c634ed',
};

export const REPORT_RANK_EXPORT = {
  name: '销售统计导出',
  api: '${ZUKER}/ma-tenant/sale/statistics/export/by/type',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#4803528ffc0b8ee69759ab8cf4fe832f',
};

export const REPORT_RECORD_LIST = {
  name: '获取销售记录列表',
  api: '${ZUKER}/ma-tenant/sale/record/query/list',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#2908d6915f048240898a942107d1e5f6',
};

export const REPORT_RECORD_EXPORT = {
  name: '导出销售记录列表',
  api: '${ZUKER}/ma-tenant/sale/record/query/list/export',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#85813b23bf7f82cc10549fc9f73c4815',
};

export const REPORT_SETTING_INFO = {
  name: '上报销售设置详情',
  api: '${ZUKER}/ma-tenant/sales/conf/info',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#8f504b71729f8ea092ddcd5e4806ddaf',
};

export const REPORT_SETTING_UPDATE = {
  name: '更新上报销售设置',
  api: '${ZUKER}/ma-tenant/sales/conf/save/or/update',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#e0f1fe026ea77448ed9dc4cd632e1d3c',
};

export const VERIFY_LIST = {
  name: '核验列表',
  api: '${ZUKER}/ma-tenant/verify/list',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#05de5c8c376c52d2a7815ababf5656e8',
};

export const ENTRY_LIST = {
  name: '出入许可列表',
  api: '${ZUKER}/ma-tenant/inout/record/page/list',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#6c1de3c7f7e0cafa136f50c745bd61e3',
};

export const ENTRY_INFO = {
  name: '出入许可详情',
  api: '${ZUKER}/ma-tenant/inout/record/detail',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#64e3ba1a07c250776d2ea309b0c12557',
};

export const ENTRY_REJECT = {
  name: '审核驳回出入许可',
  api: '${ZUKER}/ma-tenant/inout/record/audit/fail',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#9464a42b168237309dde4b2358127c6a',
};

export const ENTRY_RESOLVE = {
  name: '审核通过出入许可详情',
  api: '${ZUKER}/ma-tenant/inout/record/audit/pass',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#8ec3c7d367dc16450dbca613dd8fd89b',
};

export const ENTRY_REVOKE = {
  name: '注销出入许可',
  api: '${ZUKER}/ma-tenant/inout/record/revoke',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#47ec7611413a175934c34f3026761aff',
};

export const DELAY_LIST = {
  name: '延时闭店列表',
  api: '${ZUKER}/ma-tenant/delay/closing/page/list',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#071e9715732ebbe04304ba8c8a110d18',
};

export const DELAY_INFO = {
  name: '延时闭店详情',
  api: '${ZUKER}/ma-tenant/delay/closing/detail',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#85e0ff6994e94d30af4237d5a69570e3',
};

export const DELAY_REJECT = {
  name: '审核驳回延时闭店',
  api: '${ZUKER}/ma-tenant/delay/closing/audit/fail',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#fba994886d21dd4ef6f4678daf1e362d',
};

export const DELAY_RESOLVE = {
  name: '审核通过延时闭店详情',
  api: '${ZUKER}/ma-tenant/delay/closing/audit/pass',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#126a4fe8ac104d1550b26539327808b6',
};

export const DELAY_REVOKE = {
  name: '注销延时闭店',
  api: '${ZUKER}/ma-tenant/delay/closing/revoke',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#33cf7a340a82b42005e6a07edb0f4812',
};

export const CERT_LIST = {
  name: '员工证件列表',
  api: '${ZUKER}/ma-tenant/certificate/page/list',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#5ae6ac5d863b0702487f90ae341ba089',
};

export const CERT_INFO = {
  name: '员工证件详情',
  api: '${ZUKER}/ma-tenant/certificate/detail',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#c8003f208b02c0e88b63bd44f6ebba6a',
};

export const CERT_REJECT = {
  name: '审核驳回员工证件',
  api: '${ZUKER}/ma-tenant/certificate/audit/fail',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#fc0e73193e737ae670925479d8775ea9',
};

export const CERT_RESOLVE = {
  name: '审核通过员工证件详情',
  api: '${ZUKER}/ma-tenant/certificate/audit/pass',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#6b16bb1e992560f4821f10efdc3cccad',
};

export const CERT_REVOKE = {
  name: '注销员工证件',
  api: '${ZUKER}/ma-tenant/certificate/revoke',
  method: 'post',
  doc: 'http://192.168.15.26:8082/ma-tenant/doc.html#ea24d19e7af8fb43ebbe54e080e405c7',
};

export const FACE_SCORE_LIST = {
  name: '面对面积分列表',
  api: '${FACE2FACE}/app-face/api/score/flow',
  method: 'post',
  doc: 'http://192.168.15.56:8101/app-face/doc.html#bb145974cfc02e5fbf988d35a7c944fd',
};

export const FACE_SCORE_STATISTICS_LIST = {
  name: '面对面积分统计列表',
  api: '${FACE2FACE}/app-face/api/score/statistics',
  method: 'post',
  doc: 'http://192.168.15.56:8101/app-face/doc.html#1d2ddd187f06ad969b6b48f5a1748d70',
};

export const FACE_GIFT_MANAGE_LIST = {
  name: '面对面赠券管理列表',
  api: '${FACE2FACE}/app-face/api/D/coupon/batch/list',
  method: 'post',
  doc: 'http://192.168.15.56:8101/app-face/doc.html#955def6d79516529f0fd4faead9ebf67',
};

export const FACE_GIFT_LIST = {
  name: '面对面赠券列表',
  api: '${FACE2FACE}/app-face/api/coupon/get/flow',
  method: 'post',
  doc: 'http://192.168.15.56:8101/app-face/doc.html#e8034d520274267d1efa5f24056ee2f5',
};

export const FACE_GIFT_VERIFY = {
  name: '面对面赠券审核及上下架',
  api: '${FACE2FACE}/app-face/api/coupon/batch/status/update',
  method: 'post',
  doc: 'http://192.168.15.56:8101/app-face/doc.html#1420c3ce8f3ba14f4174f01659107076',
};

export const FACE_GIFT_STATISTICS_LIST_BY_SHOP = {
  name: '面对面赠券商户统计列表',
  api: '${FACE2FACE}/app-face/api/coupon/get/statistics/by/shop',
  method: 'post',
  doc: 'http://192.168.15.56:8101/app-face/doc.html#5e16df686f975611b5eac2dc8d33dd4c',
};

export const FACE_GIFT_STATISTICS_EXPORT_BY_SHOP = {
  name: '导出面对面赠券商户统计列表',
  api: '${FACE2FACE}/app-face/api/coupon/export/get/statistics/by/shop',
  doc: 'http://192.168.15.56:8101/app-face/doc.html#07fa77ad657a3498d4bdef6905f16bd7',
};

export const FACE_GIFT_STATISTICS_LIST_BY_COUPON = {
  name: '面对面赠券优惠券统计列表',
  api: '${FACE2FACE}/app-face/api/coupon/get/statistics/by/coupon',
  method: 'post',
  doc: 'http://192.168.15.56:8101/app-face/doc.html#89a25c2643ac9a6f48666c951dce99df',
};

export const FACE_GIFT_STATISTICS_EXPORT_BY_COUPON = {
  name: '导出面对面赠券优惠券统计列表',
  api: '${FACE2FACE}/app-face/api/coupon/export/get/statistics/by/coupon',
  doc: 'http://192.168.15.56:8101/app-face/doc.html#8f7eeafaf3986f07d128561533310b45',
};

export const FACE_REFUND_LIST = {
  name: '扫码退券列表',
  api: '${FACE2FACE}/app-face/api/coupon/return/flow',
  method: 'post',
  doc: 'http://192.168.15.56:8101/app-face/doc.html#f6fc83343b8deb810abc1e4d0ceacc47',
};

export const FACE_REFUND_STATISTICS_LIST_BY_SHOP = {
  name: '扫码退券商户统计列表',
  api: '${FACE2FACE}/app-face/api/coupon/return/statistics/by/shop',
  method: 'post',
  doc: 'http://192.168.15.56:8101/app-face/doc.html#c01221f6e0a8b38c3cf7d2d7f95bef13',
};

export const FACE_REFUND_STATISTICS_LIST_BY_COUPON = {
  name: '扫码退券优惠券统计列表',
  api: '${FACE2FACE}/app-face/api/coupon/return/statistics/by/coupon',
  method: 'post',
  doc: 'http://192.168.15.56:8101/app-face/doc.html#8dcf21a72c9fbdfcc9edcb01a3b5879c',
};
